document.addEventListener('DOMContentLoaded', function() {
    const inlineSearchContainer = document.querySelector('[data-component="inline-search-container"]');
    const inlineSearchTrigger = document.querySelector('[data-component="inline-search-trigger"]');

    if (!inlineSearchContainer || !inlineSearchTrigger) {
        return;
    }

    inlineSearchTrigger.addEventListener('click', function() {
        inlineSearchContainer.classList.toggle('tw-max-h-0');
        inlineSearchContainer.classList.toggle('tw-max-h-96');
    });
});